<template>
  <div>
    <RouterView class="app-view"></RouterView>
  </div>
</template>

<script>


export default {
  name: 'App',
  data() {
    return {
    }
  },
  methods: {
   
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body, html {
  margin: 0 !important;
  padding: 0 !important;
}


</style>